export default function ($http) {
    return function (vmcAccountId, searchTerm) {
        return $http.get('api/dealerenquiries', {params: {vmcAccountId, searchTerm}})
                .then(result => result.data);
    };
}



// WEBPACK FOOTER //
// ./Client/app/tasks/services/enquiries/getDealerEnquiries.js